export default "__VITE_ASSET__b6054268__"